import type { SVGProps } from 'react'
const SvgCall = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="call_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#call_svg__a)">
      <path d="M14.972 15.902q-2.371 0-4.686-1.033T6.07 11.937 3.135 7.72 2.102 3.033a.91.91 0 0 1 .931-.935h3.033q.365 0 .626.216a.92.92 0 0 1 .324.554l.483 2.53q.056.368-.016.624a.96.96 0 0 1-.276.446L5.36 8.269q.357.645.846 1.256.49.61 1.09 1.193.558.559 1.151 1.024t1.242.842l1.794-1.78a1.26 1.26 0 0 1 .535-.307q.317-.093.647-.038l2.466.511q.357.103.564.346a.87.87 0 0 1 .207.582v3.069q0 .4-.268.668a.9.9 0 0 1-.663.267M4.546 6.678l1.233-1.197-.31-1.677H3.832q.084.737.246 1.456.162.717.468 1.418m6.73 6.735q.705.306 1.44.489.734.183 1.48.248v-1.628l-1.673-.347z" />
    </g>
  </svg>
)
export default SvgCall
